export default __webpack_public_path__ + "static/media/john.7f2a53ae.png";